import { Link as ScrollLink } from 'react-scroll';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';
// material
import { Box, Link, Container, Typography, Fab, Zoom } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
// components
import Logo from '../../components/Logo';
//
import MainNavbar from './MainNavbar';
import MainFooter from './MainFooter';
import BottomNav from '../dashboard/BottomNav';

// ----------------------------------------------------------------------

export default function MainLayout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isHome = pathname === '/';

  return (
    <>
      <MainNavbar />
      <div>
        <Outlet />
      </div>

      {!isHome ? (
        <MainFooter />
      ) : (
        <Box
          sx={{
            py: 5,
            pb: 12, // Extra padding for bottom nav
            textAlign: 'center',
            position: 'relative',
            bgcolor: 'background.default'
          }}
        >
          <Container maxWidth="lg">
            <ScrollLink to="move_top" spy smooth>
              <Logo sx={{ mb: 1, mx: 'auto', cursor: 'pointer' }} />
            </ScrollLink>

            <Typography variant="caption" component="p">
              © All rights reserved
              <br /> made by &nbsp;
              <Link href="https://benim.be/?manouna">benim.be</Link>
            </Typography>
          </Container>
        </Box>
      )}

      {/* Floating Action Button for adding new patient */}
      <Zoom in={isHome}>
        <Fab
          color="primary"
          aria-label="Ajouter une patiente"
          onClick={() => navigate('/patiente/0')}
          sx={{
            position: 'fixed',
            bottom: 80,
            right: 16,
            zIndex: 1200,
            width: 56,
            height: 56,
            boxShadow: (theme) => `0 8px 24px ${theme.palette.primary.main}40`
          }}
        >
          <AddIcon />
        </Fab>
      </Zoom>

      <BottomNav />
    </>
  );
}
